@let filteredOptions = filteredOptions$ | async;
<mat-form-field appearance="outline" [color]="isWarning ? 'warn' : isDisabled ? 'locked' : null" [floatLabel]="floatLabel">
  <mat-label>
    @if (teamStatusIcon) {
      <span class="teams-status-icon" role="img" [ngClass]="teamStatusIcon"></span>
    }
    {{ label }}
  </mat-label>
  <input
    #inputRef
    matInput
    inputAutocompletePositioning
    mode="close"
    type="text"
    autocomplete="off"
    [class.disabled-item]="disabledItemSelected"
    [class.template-value]="itemTemplate && autoCompleteControl?.value?.id"
    [placeholder]="placeholder"
    [attr.disabled]="isDisabled"
    [required]="isRequiredControl"
    [formControl]="autoCompleteControl"
    [matAutocomplete]="auto"
    [matAutocompleteDisabled]="isDisabled"
    [errorStateMatcher]="this"
  />

  @if (isDisabled) {
    <nimbus-tooltip [text]="disabledTooltipText"></nimbus-tooltip>
  }

  @if (itemTemplate && autoCompleteControl?.value?.id) {
    <div (click)="onTemplateClick()">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { item: autoCompleteControl.value }"></ng-container>
    </div>
  }

  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    [class]="[panelClass, 'nimbus-autocomplete-panel', (emptyPanel$ | async) ? 'empty-panel' : '']"
    (optionSelected)="onOptionSelected($event)"
    (opened)="onOpen(inputRef)"
    (closed)="onClose()"
  >
    @for (optionItem of filteredOptions; track optionItem) {
      <mat-option
        [value]="optionItem"
        [disabled]="optionItem.disabled || optionItem.isGroup"
        [class.no-records]="optionItem.id === 'no_records'"
        [class.hidden-element]="optionItem.hidden"
        [class.selected-element]="selectedValue?.id === optionItem.id"
      >
        @if (!optionItem.disabled) {
          <div class="mat-option-item" [class.group]="optionItem.isGroup">
            @if (!optionItem.isGroup) {
              <div class="mat-option-text" [title]="optionItem[tooltipProp] | translate">
                @if (itemTemplate) {
                  <ng-container *ngTemplateOutlet="itemTemplate; context: { item: optionItem }"></ng-container>
                } @else {
                  {{ optionItem.name | translate }}
                }
              </div>
              <div class="disabled-item-warning-icon">
                @if (optionItem.isBeta) {
                  <i class="disable-icon" [class.beta]="optionItem.isBeta" [nimbusIcon]="icons.FLASK"></i>
                }

                @if (!!optionItem.warningItemTooltip) {
                  <i class="disable-icon" [nimbusIcon]="icons.WARNING"></i>
                  <nimbus-tooltip [text]="optionItem.warningItemTooltip | translate"></nimbus-tooltip>
                }
              </div>
            } @else {
              <div class="group-dividers"></div>

              <div class="group-text" [title]="optionItem[tooltipProp] | translate">
                @if (itemTemplate) {
                  <ng-container *ngTemplateOutlet="itemTemplate; context: { item: optionItem }"></ng-container>
                } @else {
                  {{ optionItem.name | translate }}
                }
              </div>

              <div class="group-dividers"></div>
            }
          </div>
        } @else {
          <div class="mat-option-item disabled" [class.no-records]="optionItem.id === 'no_records'">
            <div class="mat-option-text" [title]="optionItem[tooltipProp] | translate">
              @if (itemTemplate) {
                <ng-container *ngTemplateOutlet="itemTemplate; context: { item: optionItem }"></ng-container>
              } @else {
                {{ optionItem.name | translate }}
              }
            </div>

            <div class="disabled-item-warning-icon">
              @if (optionItem.isBeta) {
                <i class="disable-icon" [class.beta]="optionItem.isBeta" [nimbusIcon]="icons.FLASK"></i>
              }
              @if (optionItem.id !== 'no_records') {
                <i class="disable-icon" [nimbusIcon]="icons.WARNING"></i>
              }

              <nimbus-tooltip
                [text]="
                  optionItem.disabledItemTooltip || disabledItemTooltipText || TranslationKeys.GeneralResourceCannotBeUsed | translate
                "
              ></nimbus-tooltip>
            </div>
          </div>
        }
      </mat-option>
    }
  </mat-autocomplete>

  <ng-container matSuffix>
    <ng-content></ng-content>
  </ng-container>

  @if ((!isDisabled && !!autoCompleteControl.value) || isRemoveOnlyCase) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CLOSE_LIGHT" (click)="onClearValueClick($event)"></i>
  }

  @if (!isDisabled && !autoCompleteControl.value && (!isRemoveOnlyCase || filteredOptions?.length === 1)) {
    <i matSuffix class="cursor-pointer" [nimbusIcon]="icons.CHEVRON_DOWN_LIGHT"></i>
  }
  @if (isDisabled) {
    <i matSuffix [nimbusIcon]="icons.LOCK_LIGHT"></i>
  }

  @if (disabledItemSelected) {
    <div matSuffix class="disabled-item-warning-icon">
      @if (autoCompleteControl.value.isBeta) {
        <i class="disable-icon" [class.beta]="autoCompleteControl.value.isBeta" [nimbusIcon]="icons.FLASK"></i>
      }
      @if (autoCompleteControl.value.id !== 'no_records') {
        <i class="disable-icon" [nimbusIcon]="icons.WARNING"></i>
      }

      <nimbus-tooltip
        [text]="
          autoCompleteControl.value.disabledItemTooltip || disabledItemTooltipText || TranslationKeys.GeneralResourceCannotBeUsed
            | translate
        "
      ></nimbus-tooltip>
    </div>
  }

  @if (ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid) {
    <mat-error align="start">
      @if (isOverlayErrorMessage) {
        <nimbus-mat-icon-overlay [position]="overlayErrorMessagePosition" [icon]="icons.EXCLAMATION_TRIANGLE" [textTemplate]="text">
          <div class="overlay-error-message-body">
            <span [innerHtml]="inputValidator.getErrorMessage(ngControl.errors)"></span>
          </div>
        </nimbus-mat-icon-overlay>
        <ng-template #text>
          <span class="overlay-error-message-text" [innerHtml]="inputValidator.getErrorMessage(ngControl.errors)"></span>
        </ng-template>
      } @else {
        <i [nimbusIcon]="icons.EXCLAMATION_TRIANGLE" class="error-triangle"></i>
        <div>{{ inputValidator.getErrorMessage(ngControl.errors) }}</div>
      }
    </mat-error>
  }

  @if (warningMessage && !(ngControl && (ngControl.dirty || ngControl.touched) && ngControl.invalid)) {
    <mat-hint align="start" [ngClass]="infoMessageStyle">
      <i [nimbusIcon]="messageIcon" class="error-triangle"></i>
      <nimbus-tooltip [text]="warningMessage"></nimbus-tooltip>
      <span class="hint-message">{{ warningMessage }}</span>
    </mat-hint>
  }
</mat-form-field>
